var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXCircle = function SvgXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#27b16d89-9dc6-4472-a220-3c49ca924571a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5484D",
    fillRule: "evenodd",
    d: "M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2M.667 8a7.333 7.333 0 1 1 14.667 0A7.333 7.333 0 0 1 .667 8m4.862-2.47c.26-.26.682-.26.943 0L8 7.057 9.53 5.53a.667.667 0 1 1 .943.942l-1.529 1.53 1.529 1.528a.667.667 0 1 1-.943.943L8 8.942l-1.528 1.53a.667.667 0 0 1-.943-.943L7.058 8l-1.53-1.529a.667.667 0 0 1 0-.942",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "27b16d89-9dc6-4472-a220-3c49ca924571a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgXCircle;